import {
	Box,
	Button,
	Container,
	Divider,
	Grid,
	Typography,
} from "@mui/material";
import React from "react";
import { PropagateLoader } from "react-spinners";
import { useAPI } from "../../../../apiContext";

const Resources = () => {
	const { data } = useAPI();
	return (
		<Container sx={{ pt: 3 }}>
			{data?._id ? (
				<Box
					sx={{ border: "3px solid", borderRadius: "15px", p: 1 }}
					className='borderColor'>
					{!data?.headline?.resources === "off" ? (
						""
					) : (
						<>
							<Typography
								className='textColor'
								sx={{ mb: 0.5, fontWeight: 900 }}
								variant='h4'
								component='div'
								gutterBottom>
								{data?.headline?.resources}
								<Divider className={`${data?.color?.hr}`} />
							</Typography>
							<Grid container spacing={0} justifyContent='center'>
								{data?.scripts?.buyersGuide !== "off" && (
									<Grid item md={3} sm={4} xs={12}>
										<a style={{ textDecoration: "none" }} href='#contact'>
											<Button
												variant='contained'
												sx={{
													mb: 2,
													px: 3,
													fontWeight: "bold",
													borderRadius: "25px",
												}}>
												Buyer's Guide
											</Button>
										</a>
									</Grid>
								)}
								{data?.scripts?.sellersGuide !== "off" && (
									<Grid item md={3} sm={4} xs={12}>
										<a style={{ textDecoration: "none" }} href='#contact'>
											<Button
												variant='contained'
												sx={{
													mb: 2,
													px: 3,
													fontWeight: "bold",
													borderRadius: "25px",
												}}>
												Seller's Guide
											</Button>
										</a>
									</Grid>
								)}
							</Grid>
						</>
					)}
				</Box>
			) : (
				<div className='loader'>
					<PropagateLoader size={11} />
				</div>
			)}
		</Container>
	);
};

export default Resources;
